import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import home from './components/Home/home';
import aboutus from './components/aboutus/aboutus';
import services from './components/services/services';
import products from './components/products/products';
import technologies from './components/technologies/technologies';
import clients from './components/clients/clients';
import partners from './components/partners/partners';
import trainingclient from './components/trainingclient/trainingclient';
import contactus from './components/contactus/contactus';
import locations from './components/locations/locations';
import visionndmission from './components/visionandmission/visionndmission';
import corevalues from './components/corevalues/corevalues';
import corecompetencies from './components/corecompetencies/corecompetencies';

function App() {
  return (
   <>
      <BrowserRouter>
      <Routes>
        <Route path='/' Component={home}/>
        <Route path='/aboutus' Component={aboutus}/>
        <Route path='/visionmission' Component={visionndmission}/>
        <Route path='/corevalues' Component={corevalues}/>
        <Route path='/services' Component={services}/>
        <Route path='/corecompetencies' Component={corecompetencies}/>
        <Route path='/products' Component={products}/>
        <Route path='/technologies' Component={technologies}/>
        <Route path='/clients' Component={clients}/>
        <Route path='/partners' Component={partners}/>
        <Route path='/trainingclient' Component={trainingclient}/>
        <Route path='/contactus' Component={contactus}/>
        <Route path='/locations' Component={locations}/>
      </Routes>
      </BrowserRouter>

   
   </>
  );
}

export default App;
